import { NavLink } from "react-router-dom";
import { Home, ShoppingCart, Gamepad2, Award, User, ScrollText, Heart } from "lucide-react";
import { useStore } from "../context/StoreContext";
import sfx from "../utils/sound";

// Games sits in the CENTER (position 4 of 7) and pops out of the strip as a
// larger FAB-style tile, since it's the app's headline surface for kids.
// The rest of the tiles fan around it in the app's palette.
const items = [
  { to: "/shop",     icon: Home,         label: "Shop",     testid: "bottomnav-shop",     color: "#FF5A5F" },
  { to: "/stickers", icon: Award,        label: "Stickers", testid: "bottomnav-stickers", color: "#FFB400" },
  { to: "/wishlist", icon: Heart,        label: "Wishlist", testid: "bottomnav-wishlist", color: "#F368E0" },
  { to: "/games",    icon: Gamepad2,     label: "Games",    testid: "bottomnav-games",    color: "#5F27CD", featured: true },
  { to: "/cart",     icon: ShoppingCart, label: "Cart",     testid: "bottomnav-cart",     color: "#FFB400" },
  { to: "/orders",   icon: ScrollText,   label: "Orders",   testid: "bottomnav-orders",   color: "#00A699" },
  { to: "/profile",  icon: User,         label: "Profile",  testid: "bottomnav-profile",  color: "#54A0FF" },
];

const BottomNav = () => {
  const { cart, wishlist, canClaimDaily } = useStore();
  const cartCount = cart.reduce((s, c) => s + c.qty, 0);

  return (
    <nav
      data-testid="bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t-4"
      style={{ background: "#FFF9E6", borderColor: "#2b2b2b" }}
    >
      <ul className="grid grid-cols-7 max-w-3xl mx-auto items-end">
        {items.map(({ to, icon: Icon, label, testid, color, featured }) => (
          <li
            key={to}
            className="relative"
            data-testid={featured ? "bottomnav-games-wrap" : undefined}
          >
            <NavLink
              to={to}
              data-testid={testid}
              onClick={() => sfx.click()}
              className={({ isActive }) =>
                "flex flex-col items-center justify-center gap-1 " +
                (featured ? "pt-0 pb-2" : "py-2") + " " +
                (isActive ? "font-bold" : "")
              }
              style={({ isActive }) => ({
                color: isActive ? color : "#484848",
              })}
            >
              {({ isActive }) => (
                <>
                  <div
                    className={
                      "relative rounded-full flex items-center justify-center " +
                      (featured ? "games-fab-glow" : "")
                    }
                    style={{
                      width: featured ? 60 : 40,
                      height: featured ? 60 : 40,
                      background: featured ? color : isActive ? color : "#fff",
                      border: featured ? "4px solid #2b2b2b" : "3px solid #2b2b2b",
                      boxShadow: featured
                        ? "0 6px 0 #2b2b2b"
                        : isActive
                          ? "0 3px 0 #2b2b2b"
                          : "0 2px 0 #2b2b2b",
                      marginTop: featured ? -22 : 0,
                    }}
                  >
                    <Icon
                      size={featured ? 30 : 20}
                      strokeWidth={3}
                      color={featured || isActive ? "white" : color}
                      fill={label === "Wishlist" && isActive ? "white" : "none"}
                    />
                    {label === "Cart" && cartCount > 0 && (
                      <span
                        className="absolute -top-2 -right-2 rounded-full bg-white text-black text-xs font-bold flex items-center justify-center"
                        style={{ width: 20, height: 20, border: "2px solid #2b2b2b" }}
                      >
                        {cartCount}
                      </span>
                    )}
                    {label === "Wishlist" && wishlist.length > 0 && !isActive && (
                      <span
                        className="absolute -top-2 -right-2 rounded-full bg-white text-black text-xs font-bold flex items-center justify-center"
                        style={{ width: 20, height: 20, border: "2px solid #2b2b2b" }}
                      >
                        {wishlist.length}
                      </span>
                    )}
                    {label === "Games" && canClaimDaily && (
                      <span
                        className="absolute -top-2 -right-2 rounded-full bg-white text-black text-xs font-bold flex items-center justify-center wiggle"
                        style={{ width: 22, height: 22, border: "2px solid #2b2b2b" }}
                        data-testid="bottomnav-daily-badge"
                      >
                        🎁
                      </span>
                    )}
                  </div>
                  <span
                    className={featured ? "text-[13px] font-display" : "text-[11px]"}
                    style={featured ? { color: color, fontWeight: 700 } : undefined}
                  >
                    {label}
                  </span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
      <div style={{ height: "env(safe-area-inset-bottom)" }} />
    </nav>
  );
};

export default BottomNav;
